import { Filters } from "../../../types/filterTypes";
import Box from "@mui/material/Box";
import TextinputField from "../../CommonComponents/TextInputField/TextinputField";
import React, { useState, useRef } from "react";
import {useTheme} from "../../../contexts/theme";
import Grid from "@mui/material/Grid";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {DateRangePicker} from "@mui/x-date-pickers-pro/DateRangePicker";
import {SingleInputDateRangeField} from "@mui/x-date-pickers-pro/SingleInputDateRangeField";
import MaMStyledAutoComplete from "../../CommonComponents/MaMStyledAutoComplete/MaMStyledAutoComplete";
import {DateRange} from "@mui/x-date-pickers-pro/models";
import {Dayjs} from "dayjs";
import {ActiveFilters, useActiveFilters} from "../../../contexts/activeFilters";
import {useVideoContentTagsOptions} from "../../../contexts/VideoContentTagsOptions";
import Rating from '@mui/material/Rating';
import {FormControlLabel, IconButton, Typography} from "@mui/material";
import { styled } from "@mui/material/styles";
import StarRateRoundedIcon from "@mui/icons-material/StarRateRounded";
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import StyledCheckBox from "../../CommonComponents/StyledCheckbox/StyledCheckBox";

interface FilterProps {
    options: Filters | undefined;
    activeFilter: any;
    setActiveFilter: (name: keyof ActiveFilters, value: string | DateRange<Dayjs>, type?: string) => void;
    onAutoCompleteTextChange?: (field: keyof ActiveFilters, value: string) => void;
    autoCompleteTextValues?: Record<string, string>;
}

const Filter: React.FC<FilterProps> = ({ options, activeFilter, setActiveFilter, autoCompleteTextValues={}, onAutoCompleteTextChange= () => {}}) => {
    const [open, setOpen] = useState(false);
    const anchorEl = useRef<HTMLDivElement>(null);
    const theme = useTheme();
    const [dateRangeValue, setDateRangeValue] = React.useState<DateRange<Dayjs>>([null, null]);
    const [formattedValue, setFormattedValue] = React.useState<string[] | []>([]);

    const {setSearchOption} = useActiveFilters()

    const {videoContentTagsOptions} = useVideoContentTagsOptions()

    const handleFilter = (nameFilter: keyof ActiveFilters, values: any, options: any, type: any) => {
        if(nameFilter === 'tags'){
            const tagValues = values.map((tag: any) => typeof tag === "string" ? {id: tag, value: tag} : tag);
            setActiveFilter(nameFilter, tagValues, type)
        }else{
            setActiveFilter(nameFilter, values, type)
        }

    }

    const StyledRating = styled(Rating)(({  }) => ({
        fontSize: 26, // slightly larger stars
        "& .MuiRating-iconFilled": {
            color: "#FFC107", // amber tone for filled stars
            transition: "transform .15s",
        },
        "& .MuiRating-iconEmpty": {
            color: "transparent", // hide default fill
            stroke: theme.palette.white,
            strokeWidth: 1.2, // thin outline
            transition: "transform .15s",
        },
    }));

    const toggleAutocomplete = () => setOpen((prev) => !prev);

    return (
        <Box
            ref={anchorEl}
            sx={{
                width: "100%",
                borderRadius: `${theme.border.radius.xl}`,
            }}
        >

        <Grid container spacing={2} sx={{width: '100%'}}>
            {options &&
                (Object.keys(options) as (keyof Filters)[]).map((filterId) => {
                    if(options[filterId].type === "datarange") {
                        return (
                            <Grid item xs={12} key={filterId}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DateRangePicker
                                        slots={{ field: SingleInputDateRangeField }}
                                        value={dateRangeValue}  // Controlled value
                                        onChange={(newValue) => handleFilter(filterId as keyof ActiveFilters, newValue, [], options[filterId].type)}  // Update state on change
                                        slotProps={{
                                            actionBar: {
                                                actions: ['clear'],
                                                onClick: (action: any) => {
                                                    if (action.target.innerText as string === 'CLEAR') {
                                                        setDateRangeValue([null, null]);
                                                        setFormattedValue([]);
                                                       // removeFilter(filterId, dateRangeValue);
                                                    }
                                                },
                                            },
                                            clearButton: {
                                                sx: {
                                                    color: theme.palette.lightGrey,
                                                },
                                            },
                                            textField: {
                                                sx: {
                                                    width: '100%',
                                                    '& .MuiOutlinedInput-root': {
                                                        // Normal state
                                                        '& fieldset': {
                                                            borderColor: theme.palette.white,
                                                            borderWidth: '1px',
                                                        },
                                                        // Hover state
                                                        '&:hover fieldset': {
                                                            borderColor: theme.palette.orange,
                                                        },
                                                        // Focused state
                                                        '&.Mui-focused fieldset': {
                                                            borderColor: theme.palette.orange,
                                                        },
                                                        // 1) Change the color of the input text (the typed text)
                                                        '& .MuiInputBase-input': {
                                                            color: theme.palette.white,
                                                        },
                                                        // 2) Change the color of the label text
                                                        '& .MuiInputLabel-root': {
                                                            color: theme.palette.white,
                                                        },
                                                        // 3) Change the color of the placeholder (if any)
                                                        '& .MuiInputBase-input::placeholder': {
                                                            color: theme.palette.white,
                                                        },
                                                        '& .MuiOutlinedInput-input::placeholder': {
                                                            color: theme.palette.white,
                                                            opacity: 1,
                                                        },
                                                    },
                                                },
                                                variant: 'outlined',
                                                placeholder: options[filterId].label
                                            },
                                        }}
                                    />
                                </LocalizationProvider>
                            </Grid>
                        );
                    } else  if (options[filterId].type === "multiselect" && filterId !=='tags'){

                            return (
                                <Grid item key={filterId} xs={12}>
                                    <MaMStyledAutoComplete
                                        name={filterId}
                                        label={options[filterId].label}
                                        options={options[filterId].options || []}
                                        value={activeFilter[filterId] || []}
                                        onChange={(value, newValue) => handleFilter(filterId as keyof ActiveFilters, newValue, options[filterId].options, options[filterId].type)}
                                        backgroundColor={theme.palette.blue}
                                        customAutocomplete={true}
                                        textFieldValue={autoCompleteTextValues[filterId]}
                                        textFieldOnChange={(value) => onAutoCompleteTextChange(filterId as keyof ActiveFilters, value)}
                                        labelField={'value'}
                                        valueField={'id'}
                                    />
                                </Grid>
                            );
                    } else  if (options[filterId].type === "multiselect" && filterId ==='tags'){

                        return (
                            <Grid item key={filterId} xs={12}>
                                <MaMStyledAutoComplete
                                    freeSolo={true}
                                    name={filterId}
                                    label={options[filterId].label}
                                    options={videoContentTagsOptions.map(option => ({id: option, value:option}))|| []}
                                    value={activeFilter[filterId] || []}
                                    onChange={(value, newValue) => handleFilter(filterId as keyof ActiveFilters, newValue, options[filterId].options, options[filterId].type)}
                                    backgroundColor={theme.palette.blue}
                                    customAutocomplete={true}
                                    textFieldValue={autoCompleteTextValues[filterId]}
                                    textFieldOnChange={(value) => onAutoCompleteTextChange(filterId as keyof ActiveFilters, value)}
                                    labelField={'value'}
                                    valueField={'id'}
                                />
                            </Grid>
                        );
                    } else if (options[filterId].type === 'text'){
                        return(
                            <Grid item key={filterId} xs={12}>
                            <TextinputField name={'filter'}
                                            placeholder={options[filterId].label ?? ""}
                                            type={'text'}
                                            variant={"outlined"}
                                            value={activeFilter[filterId]}
                                            onChange={(e) => handleFilter(filterId as keyof ActiveFilters, e.target.value, options[filterId].options, options[filterId].type)}
                                            borderRadius={theme.border.radius.md}
                                            color={theme.palette.white}
                                            size={"medium"}
                                            borderColor={theme.palette.white}
                                            border={`solid 1px ${theme.palette.white}`}
                                            width={'100%'}
                                            marginBottom={filterId === 'playerSearch' ? theme.spacing.md : '0px'}
                            />
                            </Grid>
                        );
                    } else if(options[filterId].type === 'rating') {
                        return (
                            <Grid item key={filterId} xs={12}>
                                <Box display={'flex'} flexDirection={'row'} sx={{justifyContent: 'space-between', border: `1px solid ${theme.palette.white}`, borderRadius: theme.border.radius.sm, height: '56px'}}>
                                    <Box sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        p: `${theme.spacing.xs} ${theme.spacing.sm}`,
                                    }}>
                                        {/* Floating label */}
                                        <Typography
                                            component="label"
                                            htmlFor={`rating-${filterId}`}
                                            sx={{
                                                fontSize: '16px',
                                                color: theme.palette.white,
                                            }}
                                        >
                                            {options[filterId].label}
                                        </Typography>
                                    </Box>
                                    {/* Pill‑shaped wrapper to match other filters */}
                                    <Box
                                        sx={{
                                            display: "inline-flex",
                                            alignItems: "center",
                                            p: `${theme.spacing.xs} ${theme.spacing.sm}`,
                                            borderRadius: theme.border.radius.md,
                                            background: theme.palette.blue,
                                        }}
                                    >
                                        <StyledRating
                                            id={`rating-${filterId}`}
                                            name={options[filterId].name}
                                            precision={0.5}
                                            value={activeFilter[filterId]}
                                            onChange={(e, newValue) =>
                                                handleFilter(
                                                    filterId as keyof ActiveFilters,
                                                    newValue,
                                                    options[filterId].options,
                                                    options[filterId].type
                                                )
                                            }
                                            icon={<StarRateRoundedIcon fontSize="inherit" />}
                                            emptyIcon={<StarRateRoundedIcon fontSize="inherit" />}
                                        />
                                    </Box>
                                    <Box sx={{
                                        display: 'flex',
                                        alignItems: 'center'
                                    }}>
                                        <IconButton onClick={() => {
                                            handleFilter(
                                                filterId as keyof ActiveFilters,
                                                null,
                                                options[filterId].options,
                                                options[filterId].type
                                            )
                                        }}>
                                            <HighlightOffIcon sx={{color: theme.palette.white}}/>
                                        </IconButton>
                                    </Box>
                                </Box>
                            </Grid>
                        );
                    }else if(options[filterId].type === 'checkbox'){
                        return(
                            <FormControlLabel
                                sx={{
                                    color: theme.palette.white,
                                    marginLeft: theme.spacing.md,
                                    '&.Mui-disabled .MuiFormControlLabel-label': {
                                        color: theme.palette.lightGrey,
                                    }
                                }}
                                control={
                                    <StyledCheckBox
                                        height={'20px'}
                                        width={'20px'}
                                        iconSize={'20px'}
                                        checked={activeFilter[filterId]}
                                        onChange={(e) => handleFilter(filterId as keyof ActiveFilters, (e.target as any).checked, [], options[filterId].type) }
                                    />
                                }
                                label={options[filterId].label ?? ""}
                            />
                        )
                    }


                })}
        </Grid>
        </Box>
    );
};

export default Filter;
